import type { CopyShape } from "@tami/core/intl";

import type { NOTES_SCRIPT_COPY_PT_BR } from "../notes-script.copy";

export const NOTES_SCRIPT_COPY_EN_US: CopyShape<typeof NOTES_SCRIPT_COPY_PT_BR> = {
  notesIntro: {
    narrative: "Ideas hit you on the bus, in the shower, in the middle of a shoot. Notes is where they stop disappearing.",
  },
  notesToolbar: {
    narrative: "Write it down and you're done: no folders, no required title, no picking where to save.",
    callout: "\"Got an idea?\" — one click and the note is already open.",
  },
  notesList: {
    narrative: "Each note has its own color, so you spot the one you're after before you even read the title.",
    callout: "Pin what you're using to the top and the rest moves down on its own.",
  },
  notesOverview: {
    narrative: "Script drafts, reel hooks, brand briefs — all in one place.",
  },
  notesEditor: {
    narrative: "The editor saves on its own as you type. There's no save button to forget.",
    callout: "The first line becomes the title, and the rest is just writing.",
  },
};
